module.exports = __webpack_public_path__ + "img/logoword.620d3840.png";